import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { UserSettingsPanelComponent } from '../settings/user-settings-panel/user-settings-panel.component';
import { panelID } from '../settings/settings.constants';
import {
  overlayDialogRef,
  PENCIL_BOTTOM_SHEET_INSTANT_CLASS,
} from '../utilities/bottom-sheet.utils';
import { NotificationToasterService } from './notification-toaster.service';
import { LayoutSize, ScreenSizeService } from './screen-size.service';

export interface UserSettingsPanelData {
  openTab: panelID;
}

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  dialogRef?: MatDialogRef<UserSettingsPanelComponent>;
  bottomSheetRef?: MatBottomSheetRef<UserSettingsPanelComponent>;

  constructor(
    private translateService: TranslateService,
    private notificationsService: NotificationToasterService,
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    private screenSizeService: ScreenSizeService,
  ) {}

  showSettingsPanel(openTab?: panelID, skipAnimation = false): void {
    if (this.screenSizeService.layoutSize !== LayoutSize.Desktop) {
      this.bottomSheetRef = this.bottomSheet.open(UserSettingsPanelComponent, {
        panelClass: skipAnimation
          ? ['pencil-bottom-sheet', PENCIL_BOTTOM_SHEET_INSTANT_CLASS]
          : 'pencil-bottom-sheet',
        disableClose: true,
        autoFocus: false,
        data: {
          openTab,
        },
      });
      if (skipAnimation) {
        const settingsOverlay = overlayDialogRef(this.bottomSheetRef);
        this.bottomSheetRef.afterOpened().subscribe(() => {
          settingsOverlay?.removePanelClass(PENCIL_BOTTOM_SHEET_INSTANT_CLASS);
        });
      }
    } else {
      this.dialogRef = this.dialog.open(UserSettingsPanelComponent, {
        panelClass: 'user-settings-dialog-panel',
        disableClose: true,
        autoFocus: false,
        data: {
          openTab,
        },
      });
    }
  }

  showToast(message?: { title: string; description?: string }, error = false): void {
    if (!message) {
      return;
    }

    const translatedTitle = this.translateService.instant(message.title);
    const translatedDescription = message.description
      ? this.translateService.instant(message.description)
      : undefined;
    const notificationCode = this.notificationsService.generateNotificationCode();

    if (error) {
      this.notificationsService.showDefaultErrorNotificationV2(
        translatedTitle,
        translatedDescription,
        notificationCode,
      );
    } else {
      this.notificationsService.showDefaultSuccessNotification(
        translatedTitle,
        notificationCode,
        true, // activateTick
        '', // toastClass
      );
    }
  }
}
